import React from "react";
import { useTranslation } from "react-i18next";

import { mediaFilterGet } from "../../../services/api/media.js";
import { models } from "../../../services/enums/index.js";
import { DataPanelTemplate } from "../../shared/templates/index.js";
import { MediaPanelItem } from "../index.js";

export default React.memo(({ use, bgFrom }) => {
  const { t } = useTranslation();

  return (
    <DataPanelTemplate
      use={use}
      filterGet={mediaFilterGet}
      dataPrefix="medias"
      addTooltip="add_media"
      sortDescs={[
        { label: t("from_newest"), desc: "-createdAt" },
        { label: t("from_oldest"), desc: "createdAt" },
      ]}
      model={models.MEDIA}
      panelItem={MediaPanelItem}
      bgFrom={bgFrom}
    />
  );
});
